<template>
    <article id="home-page">

        <div id="validating-login" v-if="!shouldShowLandingPage && !failedLogin">
            <div class="loading large">
                <i class="fa fa-refresh fa-spin"></i>
                <p>Validating Login</p>
            </div>
        </div>

        <template v-if="shouldShowLandingPage || failedLogin">

            <div id="headline">
                <div class="logo-container">
                    <img class="logo" src="/static/mixsii-logo.svg"/>
                </div>

                <div class="login-container">
                    <button @click.prevent="toggleLoginForm">
                        <template v-if="!showLoginForm">Login</template>
                        <template v-else><i class="fa fa-chevron-left"></i> Return</template>
                    </button>

                </div>
            </div>

            <div id="upsell">
                <transition name="fade" mode="out-in">
                    <template v-if="showLoginForm">
                        <login-form></login-form>
                    </template>

                    <div id="pitch-container" v-else>

                        <div class="pitch">
                            <div class="description">
                                <h1><i class="fa fa-video-camera"></i> Free Video Chat</h1>
                                <h1><i class="fa fa-user-plus"></i> Make New Friends</h1>
                                <h1><i class="fa fa-close"></i> No Download</h1>
                                <h1><i class="fa fa-money"></i> 100% Free!</h1>
                            </div>

                            <div class="preview">
                                <img src="/static/landing-page-preview-image.png">
                            </div>
                        </div>

                        <div class="registration">
                            <register-form></register-form>
                        </div>
                    </div>
                </transition>


                <div id="ad-container">
                    <ad-container ad-slot="2462240339"></ad-container>
                </div>

            </div>

            <template v-if="!showLoginForm">
                <h1 id="feature-header">Features</h1>

                <div id="features">
                    <div class="feature">
                        <h1>1 on 1 Video Calls</h1>
                        <p>HD Video Chat with friends, family, and strangers completely free from your web browser. No download required to make it work!</p>
                    </div>
                    <div class="feature">
                        <h1>Group Video Calls</h1>
                        <p>HD Video Chat with a whole group! Video Conferencing is free, easy to set up, and fun!</p>
                    </div>
                    <div class="feature">
                        <h1>Share Gifs</h1>
                        <p>Chat has never been more fun with the ability to easily search and send animated Gifs right into the chatroom!</p>
                    </div>
                    <div class="feature">
                        <h1>Meet New People</h1>
                        <p>With public chatrooms, group chats, and private chats, you can chat how ever you want to! Make friends that will last a life time. Video Chatting strangers is fun and safe!</p>
                    </div>
                    <div class="feature">
                        <h1>Share Files</h1>
                        <p>Upload and send files to your friends and group chats easily with the click of a button. On mobile, you can even send a live camera picture.</p>
                    </div>
                    <div class="feature">
                        <h1>User Profiles</h1>
                        <p>Express yourself on your Profile with a Bio and up to ten photos. Browse other members profiles to find new friends, look at photos, and read bios.</p>
                    </div>
                    <div class="feature">
                        <h1>Cross-Platform</h1>
                        <p>Mixsii works on all browsers and mobile devices! It looks good on Desktop, Tablet, and Mobile. Video Chat also works on all platforms!</p>
                    </div>
                    <div class="feature">
                        <h1>Themes</h1>
                        <p>Customize the way your chat panel looks by selecting your own color pallet!</p>
                    </div>
                    <div class="feature">
                        <h1>Markdown Text Messages</h1>
                        <p>All Chat Messages support the Markdown Language, allowing you to easily format text posts with bold and italic words.</p>
                    </div>
                </div>
            </template>
        </template>

    </article>
</template>

<script>
    import LoginForm from './LoginForm.vue';
    import RegisterForm from './RegisterForm.vue';
    import AdContainer from '../Common/AdContainer.vue'

    export default {
        name: 'HomePage',

        components: {
            'login-form': LoginForm,
            'register-form': RegisterForm,
            'ad-container': AdContainer
        },

        data() {
            return {
                failedLogin: false,
                showLoginForm: false,
                showRegisterForm: false
            }
        },

        computed: {
            shouldShowLandingPage(){
                let cookieEntries = document.cookie.split(';');
                let cookies = {};

                cookieEntries.forEach((cookie) => {
                    let cookieSegments = cookie.split('=');
                    if (cookieSegments.length === 2) {
                        cookies[cookieSegments[0].trim()] = cookieSegments[1].trim();
                    }
                });

                return (!cookies.passKey || !cookies.password);
            },

            fetchedLoginStatus(){
                return !this.$store.state.loggedUserModel.gotInitialLoggedUserInfo;
            }
        },

        methods: {
            toggleLoginForm(){
                this.showLoginForm = !this.showLoginForm;
            }
        },
        watch: {
            'fetchedLoginStatus'(){
                if (this.$store.state.loggedUserModel.isLoggedIn) {
                    this.$router.push('/Chat');
                } else {
                    this.failedLogin = true;
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// HomePage.vue?09e619ff